export default __webpack_public_path__ + "static/media/l1-p3.a9be63b3.png";